<template lang="pug">
#TeamFilter
    //- select#TeamFilter.w4(v-model="selected")
    //-     option(v-for="option of options" :value="option.value")
    //-         | {{ option.text }}
    .options.h5.scroll-y
        div.mb2(v-for="option of options")
            .pretty.p-default.p-smooth(v-if="option.value")
                input(type="checkbox"  v-model="checked[option.value]")
                .state
                    label(v-if="option.value")
                        | {{ option.text }}
    .pretty.p-default.p-smooth.mt4
        input(type="checkbox"  v-model="selectAll")
        .state
            label {{ selectAll ? 'Unselect all' : 'Select all' }}

</template>

<script>
import { EventBus } from '../EventBus';
import teamNames from '../teams';
window.teamNames = teamNames;
export default {
    name: 'TeamFilter',
    data: function() {
        const out = {
            selected: '',
            checked: {},
            selectAll: true
        };
        for (const team of Object.keys(teamNames)) {
            out.checked[team] = true;
        }
        // for (let i = 0; i < 60; i++) {
        //     out.checked[i] = true;
        // }
        return out;
    },
    created() {
        window.TeamFilter = this;
        EventBus.$on('map-loaded', () => {
            window.log('here it comes');
            this.sendUpdate();
        });
    },
    computed: {
        options() {
            return [
                { text: 'All teams', value: '' },
                ...Object.keys(teamNames).map(id => ({
                    value: +id,
                    text: `${teamNames[id]
                        .replace(/\d+_/, '')
                        .replace(/_/g, ' ')} (${id})`
                }))
            ];
        }

        // return [
        //     { text: 'All teams', value: '' },
        //     ...Array(59)
        //         .fill()
        //         .map((_, i) => ({ value: i + 1, text: `Team ${i + 1}` }))
        // ];
    },
    methods: {
        sendUpdate() {
            EventBus.$emit('team-filter', this.selected, this.checked);
        }
    },
    watch: {
        selected() {
            this.sendUpdate();
        },
        checked: {
            deep: true,
            handler() {
                this.sendUpdate();
            }
        },
        selectAll: {
            immediate: true,
            handler() {
                for (const option of this.options) {
                    this.checked[option.value] = this.selectAll;
                }
            }
        }
    }
};
</script>

<style scoped>
.options {
    overflow-y: scroll;
    /* background-color: hsl(0, 0%, 3.1%); */
    /* background-color: hsl(0, 0%, 6.3%); */
    /* background-color: hsl(0, 0%, 9.4%); */
    border: 1px solid hsl(0, 0%, 6.3%);
    padding: 0.25em 0.5em;
    font-size: 14px;
}
</style>
